import { HttpLink } from 'apollo-link-http';

export const httpLink = new HttpLink({
  uri: '/api/graphql',
  credentials: 'same-origin',
});

export default httpLink;
